import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-gutter-y-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_post_search_loader = _resolveComponent("post-search-loader")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: _ctx.title,
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Save",
        color: "primary",
        task: _ctx.task,
        disabled: !_ctx.canSave,
        onClick: _ctx.save
      }, null, 8, ["task", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_post_search_loader, {
        "post-search-id": _ctx.postSearchId,
        modelValue: _ctx.postSearch,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.postSearch) = $event))
      }, null, 8, ["post-search-id", "modelValue"]),
      (_ctx.postSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postSearch.keywords, (kw, i) => {
              return (_openBlock(), _createBlock(_component_q_input, {
                key: i,
                "model-value": kw,
                dense: "",
                readonly: ""
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_q_btn, {
                    icon: "fa fa-trash",
                    title: "Remove keyword",
                    flat: "",
                    round: "",
                    dense: "",
                    onClick: ($event: any) => (_ctx.removeKeyword(kw))
                  }, null, 8, ["onClick"])
                ]),
                _: 2
              }, 1032, ["model-value"]))
            }), 128)),
            _createVNode(_component_q_input, {
              modelValue: _ctx.keyword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.keyword) = $event)),
              placeholder: "Add keyword...",
              dense: "",
              autofocus: "",
              onKeyup: _withKeys(_ctx.addKeyword, ["enter"])
            }, {
              append: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  icon: "fa fa-plus",
                  flat: "",
                  round: "",
                  onClick: _ctx.addKeyword
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["modelValue", "onKeyup"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}